'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isActiveOnThread = isActiveOnThread;

var _getSelectedThreadId = require('../../selected-thread/selectors/getSelectedThreadId');

var _getIsInForeground = require('./getIsInForeground');

function isActiveOnThread(state, threadId) {
  var selectedThreadId = (0, _getSelectedThreadId.getSelectedThreadId)(state);
  return threadId === selectedThreadId && (0, _getIsInForeground.getIsInForeground)(state);
}